"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addFee = void 0;
var to_bn_1 = require("../common/to-bn");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var big_number_1 = require("@rarible/types/build/big-number");
function addFee(asset, fee) {
    var value = to_bn_1.toBn(asset.value).multipliedBy(10000 + fee).dividedBy(10000).integerValue(bignumber_js_1.default.ROUND_FLOOR);
    return __assign(__assign({}, asset), { value: big_number_1.toBigNumber(value.toFixed()) });
}
exports.addFee = addFee;
